import {Directive, HostBinding, Input, NgModule, OnInit} from '@angular/core';
import {UserService} from '../../../../user/src/lib/user.service';
import {ProfessionsMap} from '../../../../journal/src/_interface/professions.map';

@Directive({
	selector: '[libHideByProfession]'
})
export class HideByProfessionDirective implements OnInit {
	@HostBinding('class.d-none') get displayNone() { return this.hide; }
	@Input() professions: string[] = [];
	hide = false;
	profession = this.user.user?.profession;

	constructor(private user: UserService) {}

	ngOnInit() {
		for (const array of ProfessionsMap) {
			const ids = array[0];
			const profession = array[1];
			if (ids.includes(+this.profession)) {
				this.hide = this.professions.includes(profession);
			}
		}
	}
}

@NgModule({
	declarations: [HideByProfessionDirective],
	exports: [HideByProfessionDirective]
})
export class HideByProfessionDirectiveModule {}
